// Mapper: transport LC_GetMyTeamMonthlyOvertimeSummaryOut → domain model for the
// "Mi equipo" dashboard "Resumen del mes" — "Horas extras" card (ASIS-5409 / REXASIS-008).
// The backend only sends the raw hours; the percentage/isEmpty business rules are
// computed here so the UI never re-implements them.
//
// totalHours (calculated, caHistoricoLibroAsistenciaDet) and approvedHours (justified,
// caHorasExtraJustificadas) come from different subsystems, so approved <= total is not
// guaranteed — the backend already clamps pendingHours to 0 for the same reason. percentage
// is clamped to 100 here to match, and isEmpty requires both to be 0 so a mismatch (e.g.
// total=0 with approved>0) never renders as the empty state.

import type {
  LC_GetMyTeamMonthlyOvertimeSummaryOut,
  MyTeamMonthlyOvertimeSummary,
} from '../types/myTeamMonthlyOvertimeSummary.types';


export function mapMyTeamMonthlyOvertimeSummary(
  out: LC_GetMyTeamMonthlyOvertimeSummaryOut,
): MyTeamMonthlyOvertimeSummary {
  const isEmpty = out.totalHours === 0 && out.approvedHours === 0;
  const percentage = isEmpty
    ? 0
    : Math.min(100, Math.round((out.approvedHours / out.totalHours) * 100));

  return {
    totalHours: out.totalHours,
    approvedHours: out.approvedHours,
    pendingHours: out.pendingHours,
    percentage,
    isEmpty,
  };
}
